import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { ContentSectionState, ContentSectionStore } from './content-section.store';

@Injectable({ providedIn: 'root' })
export class ContentSectionQuery extends QueryEntity<ContentSectionState> {
	constructor(protected override store: ContentSectionStore) {
		super(store);
	}
}
